import type { FlowAccumulator, RequestTokenFn } from '../model'
import { getDefaultHeaders } from '../utils/getDefaultHeaders'
import set from 'lodash/set'

export const execHttpRequest =
  (requestToken: RequestTokenFn) => async (acc: FlowAccumulator) => {
    const backendApiUrl = process.env.NEXT_PUBLIC_API_URL
    const { apiUrl, reqConfig, method, sessionFingerprint } = acc
    const tokens = requestToken()

    let privyToken: string | null = null
    if (!reqConfig.skipAuthorization) {
      const { getAccessToken } = await import('@privy-io/react-auth')
      privyToken = await getAccessToken()
    }

    reqConfig.signal?.throwIfAborted()

    acc['tokens'] = {
      tokens: {
        access: {
          token: privyToken || '',
        },
      },
      user: tokens.user,
    }

    const headers = {
      ...getDefaultHeaders(reqConfig),
      ...reqConfig?.headers,
    }

    if (
      apiUrl.includes('//api-dev.') ||
      apiUrl.includes('//api-stage.') ||
      apiUrl.includes('//api.')
    ) {
      if (sessionFingerprint && reqConfig.skipFingerprint !== false) {
        headers['X-Session-Fingerprint'] = sessionFingerprint
      }
    }

    if (!reqConfig.skipAuthorization) {
      set(headers, 'Authorization', `Bearer ${privyToken}`)
    }

    try {
      const response = await fetch(apiUrl, {
        signal: reqConfig.signal,
        method,
        body: method !== 'GET' ? acc.bodyTransformed : undefined,
        headers: headers as HeadersInit,
        credentials: apiUrl.includes(backendApiUrl || '')
          ? 'include'
          : reqConfig.credentials
            ? reqConfig.credentials
            : undefined,
      })

      acc.response = response
    } catch (error) {
      acc.error = error as Error
    }

    return acc
  }
